import { render } from "./ClanderCalendar.vue?vue&type=template&id=cbcadba8&scoped=true"
import script from "./ClanderCalendar.vue?vue&type=script&lang=js"
export * from "./ClanderCalendar.vue?vue&type=script&lang=js"

import "./ClanderCalendar.vue?vue&type=style&index=0&id=cbcadba8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbcadba8"]])

export default __exports__